// src/components/filter/SizeFilter.jsx

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFilter } from "../../redux/actions/filterActions";

const SizeFilter = () => {
  const dispatch = useDispatch();
  const {
    loading: optionsLoading,
    data: filterOptions = {},
    error: optionsError,
  } = useSelector((state) => state.filterOptions) || {};
  const chosenFilters = useSelector((state) => state.filters) || {};
  const sizes = filterOptions.sizes || [];

  if (optionsError) return <p>Error loading sizes: {optionsError}</p>;
  if (optionsLoading) return <p>Loading sizes…</p>;

  return (
    <div className="my-4">
      <h6 className="font-semibold lg:text-lg mb-2">Sizes</h6>
      <div className="flex flex-wrap gap-2">
        {sizes.map((sz) => (
          <button
            key={sz.size_id}
            onClick={() => {
              const updated = chosenFilters.sizes.includes(sz.size_name)
                ? chosenFilters.sizes.filter((s) => s !== sz.size_name)
                : [...chosenFilters.sizes, sz.size_name];
              dispatch(setFilter("sizes", updated));
            }}
            className={`px-3 py-1 rounded border ${
              chosenFilters.sizes.includes(sz.size_name)
                ? "bg-medium-theme-color text-white"
                : "bg-white text-black border-black"
            }`}
          >
            {sz.size_name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SizeFilter;
